<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h3>Recursos / Consignas Escritas</h3>
        </b-col>
    </b-row>
    <div class="card">
      <div class="tab-content">
        <div class="table-responsive">
          <div class="d-flex justify-content-between align-items-center mb-4 pl-4">
            <b-pagination class="p-0 m-0"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table">
            </b-pagination>
            <div class="d-flex align-items-center pl-3 mr-auto">
              <label class="p-0 m-0 pr-3 text-purple">Filtrar por tags</label>
              <vue-tags-input
                v-model="taglist"
                :autocomplete-items="tagslist"
                :add-only-from-autocomplete="true"
                @tags-changed="updatelist"
              />
            </div>
             <div class="col-md-3">
              <ResourceSearchs :routeApi="'writteninstructions'" ref="searchcomponent"
                :perPage = "perPage"
                :newTags2 = "newTags2"
                @update="onUpdateDataResource"
                @loading="onLoading"
              />
            </div>
            <b-button @click="onNew" variant="success">
              + Añadir
            </b-button>
          </div>
          <b-table hover :items="resources"
          :fields="fields"
          :per-page="0"
          :current-page="currentPage"
          >
            <template v-slot:cell(TEXTOS)="data">
              {{ data.item.TEXTOS[languages.indexOf(languageGlobal)].TEXTO }}
            </template>
            <template v-slot:cell(actions)="row">
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-info" @click="info(row.item, row.index, $event.target)">
                <i class="zmdi zmdi-edit"></i>
              </b-button>
              <b-button class="btn btn-icon btn-icon-mini btn-round btn-danger" @click="ondelete(row.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
  <!-- Info modal -->
    <b-modal :id="infoModal.id" size="xl" :title="infoModal.title" hide-footer>
       <div class="modal-body">
              <div class="d-block ">
                <div>
                  <label for="">Título de la consigna escrita</label>
                  <b-form-input
                    id="textarea"
                    v-model="selectedItem.TITULO"
                    maxlength="255"
                    placeholder="Título de la consigna..."
                    :state="($v.selectedItem.TITULO.$dirty && submitted)?
                    !$v.selectedItem.TITULO.$error : null"
                    aria-describedby="nombre-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="nombre-feedback">
                    Este campo es requerido.
                  </b-form-invalid-feedback>
                  <br>
                  <hr />
                  <b-row>
                    <b-col style="text-align:center" class="d-flex justify-content-center align-items-center">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="selectedItem.TEXTOS_ID !== null && selectedItem.TEXTOS_ID !== 0"
                        @click="openResourceWithParam('texts', selectedItem.TEXTOS_ID)"/>
                      <searchtexts idModal="mdlSearchTexts"
                        v-on:selected="onSelected($event)">
                      </searchtexts>
                    </b-col>
                  </b-row>
                  <b-form-invalid-feedback id="textos_id-feedback" style="text-align:center">
                    Debe buscar un Texto existente
                  </b-form-invalid-feedback>
                  <label for="">Texto</label>
                  <b-form-textarea
                    id="textarea"
                    v-bind:value="getTranslation(selectedItem.TEXTOS)"
                    placeholder="Texto Español..."
                    rows="3"
                    max-rows="6"
                    :readonly=true
                  >
                  </b-form-textarea>
                </div>
              </div>
              <br>
                          <label>Etiquetas</label>
                            <div>
                            <vue-tags-input
                              v-model="tag"
                              :tags="tags"
                              :autocomplete-items="autocompleteItems"
                              @tags-changed="update"
                            />
                          </div>
              <div class="modal-footer">
                <button type="button" @click="save"
                class="btn btn-info btn-round waves-effect">
                  Guardar</button>
                <b-button class="btn btn-default btn-round waves-effect" block
                @click="$bvModal.hide('info-modal')">Cerrar</b-button>
            </div>
        </div>
    </b-modal>
</div>

</template>

<script>
import { required } from 'vuelidate/lib/validators';
import VueTagsInput from '@johmun/vue-tags-input';
import searchtexts from '../texts/SearchTexts.vue';
import ResourceSearchs from '../../../components/panel/ResourceSearchs.vue';
import searchMixin from '../../../mixins/search';
import translationMixin from '../../../mixins/translation';

export default {
  name: 'gridWrittenInstructions',
  mixins: [searchMixin, translationMixin],
  components: { searchtexts, VueTagsInput, ResourceSearchs },
  data() {
    return {
      mounted: null,
      perPage: 20,
      rows: 0,
      submitted: false,
      currentPage: 1,
      fields: [
        { key: 'TITULO', label: 'Título' },
        { key: 'TEXTOS', label: 'Texto' },
        { key: 'actions', label: 'Acciones', tdClass: 'tdActionClass' },
      ],
      resources: [],
      selectedItem: {
        ID: null,
        TITULO: null,
        TEXTOS: [],
        TEXTOS_ID: null,
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      tag: '',
      tags: [],
      newTags: [],
      tagslist: [],
      newTags2: [],
      taglist: '',
      autocompleteItems: [],
    };
  },
  validations: {
    selectedItem: {
      TITULO: {
        required,
      },
      TEXTOS_ID: {
        required,
      },
    },
  },
  methods: {
    onSelected(itemSelected) {
      this.selectedItem.TEXTOS = itemSelected.TEXTOS;
      this.selectedItem.TEXTOS_ID = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', 'mdlSearchTexts');
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.languages.forEach((language) => {
        this.selectedItem.TEXTOS.push({
          LANGUAGE: language,
          TEXTO: null,
        });
      });
      this.infoModal.title = 'Crear consigna escrita';
      this.tag = '';
      this.tags = [];
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.TEXTOS_ID = null;
      this.selectedItem.TITULO = null;
      this.selectedItem.TEXTOS = [];
      this.tag = '';
      this.tags = [];
    },
    initItems() {
      const url = 'Tags';
      const datos = [];

      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    listTags() {
      const url = 'Tags';
      const datos = [];
      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ key: a.ID, text: a.NOMBRE });
        });
        this.tagslist = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    update(newTags) {
      this.tags = newTags;
      this.newTags = newTags;
    },
    updatelist(newTags) {
      this.newTags2 = newTags;
      this.getPostData();
    },
    async getExistingTags(idconsigna) {
      const url = `Tagsconsignasescritas/findByconsigna/${idconsigna}`;
      const datos = [];
      this.loading = true;

      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    async ondelete(item) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar un registro ¿Esta seguro?');
      if (confirmation) {
        this.loading = true;
        const response = await this.axios.post('writteninstructions/delete', { ID: item.ID });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.getPostData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    info(item, index, button) {
      this.submitted = false;
      this.infoModal.title = 'Editar consigna escrita';
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.selectedItem.ID = item.ID;
      this.selectedItem.TEXTOS_ID = item.TEXTOS_ID;
      this.selectedItem.TITULO = item.TITULO;
      this.selectedItem.TEXTOS = item.TEXTOS;
      this.getExistingTags(item.ID);
      this.$root.$emit('bv::show::modal', this.infoModal.id, button);
    },
    async save() {
      this.submitted = true;
      this.$v.selectedItem.$touch();
      if (this.$v.selectedItem.$anyError) {
        return;
      }
      this.loading = true;
      const textData = {
        ID: this.selectedItem.ID || -1,
        TITULO: this.selectedItem.TITULO,
        TEXTOS_ID: this.selectedItem.TEXTOS_ID,
      };
      try {
        const response = await this.axios.post('writteninstructions/store', textData);
        if (response.data.status === 'success') {
          const bc = new BroadcastChannel('new_resource_writteninstructions');
          bc.postMessage(response.data.textDynamic);

          const url = `Tagsconsignasescritas/deleteTags/${response.data.id}`;
          const url2 = 'Tagsconsignasescritas/saveTag';

          this.axios.get(url);
          this.newTags.forEach((a) => {
            this.axios.get(`Tags/findTagByName/${a.text}`,
              { name: a.text }).then((resp) => {
              if (resp.data.status === 'success') {
                this.axios.post(url2, { id: resp.data.id, idconsigna: response.data.id });
              } else {
                this.axios.post(url2, { id: a.key, idconsigna: response.data.id });
              }
            });
          });

          this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
          this.$root.$emit('bv::hide::modal', this.infoModal.id);
          this.limpiar();

          // Auto close if coming from a create event
          if (this.bAutoClose) {
            window.open('', '_self').close();
          }

          this.getPostData();
        } else {
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      } catch (e) {
        const resp = e;
        if (!resp.body.Ok) {
          this.$toasted.show(resp.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
        }
        this.loading = false;
      }
    },
    async getPostData() {
      this.loading = true;
      try {
        const response = await this.axios.get('writteninstructions', {
          params: {
            currentPage: this.currentPage,
            size: this.perPage,
            newTags: this.newTags2,
            resourcetosearch: this.$refs.searchcomponent.resoursetosearch,
          },
        });
        this.rows = response.data.rows;
        this.resources = Object.keys(response.data.results).map(k => response.data.results[k]);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.getPostData();
    this.initItems();
    this.listTags();

    // Open create modal automatically
    const self = this;
    const bc = new BroadcastChannel('new_resource_writteninstructions_open');
    bc.onmessage = () => {
      self.bAutoClose = true;
      self.onNew();
    };

    if (this.$route.params.id != null) {
      this.loading = true;
      const response = await this.axios.get('writteninstructions/getwritteninstruction', {
        params: {
          id: this.$route.params.id,
        },
      });
      const item = response.data;
      this.loading = false;
      this.info(item, null, null);
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getPostData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style>
  .tdActionClass{
    width: 180px;
    text-align: center
  }
</style>
